<script lang="ts" setup>
    import { onMounted, ref, computed } from 'vue';
    import ChoiceTable from "../../components/ChoiceTable.vue";
    import { ICol, ValueStrDelegate } from "../../lib/ChoiceTableHelpers";
    import { MenuNameType } from "../../Enums/ChoiceEnums";
    import { TableRowType } from "../../Enums/UiEnums";
    import { ICompanyFolderUsageItem, ICompanyFolderUsageResults } from '../../lib/Models/CompanyModel';
    import '../../../css/choice.css';

    const tableData = ref<ICompanyFolderUsageItem[]>([]);
    const windowHeight = ref<number>();
    
    const FormatMenuName: ValueStrDelegate = (value: any, col: ICol, row: Record<string, any> | undefined, rowType: TableRowType): string | undefined => {
        if (rowType === TableRowType.Body)
        {
             return MenuNameType[row?.menuNameId];
        }
    }

    const FormatSizeMb: ValueStrDelegate = (value: any, col: ICol, row: Record<string, any> | undefined, rowType: TableRowType): string | undefined => {
        if (rowType === TableRowType.Body)
        {
             return ((row?.documentSize ?? 0) / 1048576.0).toFixed(3).toString();
        }
    }
    
    const tableColumns = ref<ICol[]>([
        { Name: 'Location', DataField: 'menuNameId', FormatValue: FormatMenuName },
        { Name: 'Path', DataField: 'documentPath' },
        { Name: 'Count', DataField: 'documentCount' },
        { Name: 'Size (MB)', DataField: 'documentSize', FormatValue: FormatSizeMb },
    ]);

    const props = defineProps<{
        folderResults: ICompanyFolderUsageResults
    }>();


    onMounted(async () => {
        tableData.value = props.folderResults.folderList;
        windowHeight.value = window.innerHeight - 70;
        window.addEventListener('resize', () => {
            windowHeight.value = window.innerHeight - 70;
        })
    });

    const totalDiskSpace = computed<number>(() => props.folderResults.folderList.reduce((sum, current) => sum + current.documentSize, 0));
    const totalDiskSpaceMb = computed<string>(() => `${((totalDiskSpace?.value ?? 0) / (1024.0 * 1024.0)).toFixed(3)} MB`);
    const totalDiskSpaceGb = computed<string>(() => `${((totalDiskSpace?.value ?? 0) / (1024.0 * 1024.0 * 1024.0)).toFixed(3)} GB`);
    const totalDocTotal = computed<number>(() => props.folderResults.folderList.reduce((sum, current) => sum + current.documentCount, 0));

</script>

<template>
    <div class="row">
        <div class="col-auto label-isalus-small text-primary">
            Total Disk Space = {{ totalDiskSpaceGb }} = {{ totalDiskSpaceMb }}
        </div>
        <div class="col-auto label-isalus-small text-primary">
            Total Document Count = {{ totalDocTotal }}
        </div>
        <div class="col d-flex justify-content-end label-isalus-small">
            NOTE: 1 Gigabyte (GB) = 1,024 Megabytes (MB)
        </div>
    </div>
    <div class="row mt-2">
        <div class="col">
            <p style="font-size: 0.75rem;">
                <ChoiceTable 
                    ref="folderUsageTable"
                    :columns="tableColumns" 
                    :data="tableData" 
                    :show-filters="false" 
                    :allowSorting="false"
                    :height="windowHeight"
                    :key-value-data-member="'Col3Val'">Loading...
                </ChoiceTable>
            </p>
        </div>
    </div>
</template>

